<template>
  <div class="Wysiwyg">
    <h2 class="title" v-if="title" v-html="title"></h2>
    <div class="content" v-if="content" v-html="content"></div>
  </div>
</template>

<script>
  export default {
    name: 'Wysiwyg',
    props: {
      title: {
        type: String,
        default: ""
      },
      content: {
        type: String,
        default: ""
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '~@less/wysiwyg';
</style>
